/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpgradeInfo } from './upgradeInfo';


export interface LastUpgrade { 
    /**
     * Time for the upgrade last operation, triggerred or status update
     */
    created_at: Date;
    from_version: string;
    to_upgrade_info: UpgradeInfo;
    to_version: string;
}

